import { slugifyRegionName } from '../../../../lib/regionSlug';
import type { ViewMode } from '../../../../shared/nav/viewMode';
import { useAllRegionsOverview } from '../overview/overview-api';
import { overviewHrefFor } from '../overview/overview-path';

interface WorkshopRegion {
  venueRegionId: string | null;
  venueRegionName: string | null;
}

/**
 * The calendar of the region a workshop belongs to: the region's Overview for
 * staff, and Region schedule for a teacher. Null when the workshop has no
 * region, or while (or if) the admin region list can't be read.
 */
export function useRegionCalendarHref(mode: ViewMode, region: WorkshopRegion): string | null {
  const isAdmin = mode === 'admin';
  const { data } = useAllRegionsOverview({ enabled: isAdmin && region.venueRegionId !== null });

  if (!region.venueRegionId || !region.venueRegionName) return null;
  if (!isAdmin) {
    return `/me/region-schedule?region=${encodeURIComponent(slugifyRegionName(region.venueRegionName))}`;
  }
  const row = data?.regions.find((r) => r.id === region.venueRegionId);
  return row ? overviewHrefFor(row.path) : null;
}
